<template>
  <div class="usage-restriction">
    <div class="question">{{ $t('promotion_new.constraint') }}</div>
    <div class="radios">
      <div class="radio">
        <input id="chk_no_limit" type="radio" value="unlimited" v-model="promotion.usageRestriction">
        <label for="chk_no_limit">{{ $t('no_limit') }}</label>
        <input id="chk_once_per_user" type="radio" value="once_per_user" v-model="promotion.usageRestriction">
        <label for="chk_once_per_user">{{ $t('once_per_user') }}</label>
      </div>
      <div class="radio">
        <input id="chk_on_first_order" type="radio" value="on_first_order" v-model="promotion.usageRestriction">
        <label for="chk_on_first_order">{{ $t('on_first_order') }}</label>
        <input id="chk_once_ever" type="radio" value="once_ever" v-model="promotion.usageRestriction">
        <label for="chk_once_ever">{{ $t('unique_use') }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromotionUsageRestriction",

  props: {
    promotion: Object
  }
}
</script>